import { pipe } from 'fp-ts/function';
import { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { isSubmitting, submit, SubmitHandler } from 'redux-form';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import EditDialogForm, { EditDialogFormProps } from './EditDialogForm';

interface StateProps {
    loading: boolean;
}

interface DispatchProps {
    handleSubmit: SubmitHandler;
}

type OwnProps = PropsWithChildren<Omit<EditDialogFormProps, 'handleSubmit' | 'loading'>> & {
    formName: string;
};

const ConnectedEditDialogForm = pipe(
    EditDialogForm,
    connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
        (state, { formName }) => ({
            loading: isSubmitting(formName)(state),
        }),
        (dispatch: CommanderThunkDispatch, { formName }) => ({
            handleSubmit: () => dispatch(submit(formName)),
        })
    )
);

export default ConnectedEditDialogForm;
